module.exports = __webpack_public_path__ + "static/media/Chair_Arm_After.80f32ea7.jpg";